<template>
  <base-icon-button v-on="$listeners"
                    :title="title">
    <base-material-design-icon icon="assignment"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonAssignment',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        default: 'Experiment report PDF',
        validator: (value) => value.length > 0,
      },
    },
  };
</script>

<style scoped>

</style>
